import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ExportOpsOrderMutationVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.OpsOrderFilter>;
  ids?: Types.InputMaybe<Array<Types.Scalars['ID']> | Types.Scalars['ID']>;
}>;


export type ExportOpsOrderMutation = { __typename?: 'Mutation', exportOpsOrder: string };


export const ExportOpsOrderDocument = gql`
    mutation ExportOpsOrder($filter: OpsOrderFilter, $ids: [ID!]) {
  exportOpsOrder(filter: $filter, ids: $ids)
}
    `;
export type ExportOpsOrderMutationFn = Apollo.MutationFunction<ExportOpsOrderMutation, ExportOpsOrderMutationVariables>;

/**
 * __useExportOpsOrderMutation__
 *
 * To run a mutation, you first call `useExportOpsOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportOpsOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportOpsOrderMutation, { data, loading, error }] = useExportOpsOrderMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useExportOpsOrderMutation(baseOptions?: Apollo.MutationHookOptions<ExportOpsOrderMutation, ExportOpsOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportOpsOrderMutation, ExportOpsOrderMutationVariables>(ExportOpsOrderDocument, options);
      }
export type ExportOpsOrderMutationHookResult = ReturnType<typeof useExportOpsOrderMutation>;
export type ExportOpsOrderMutationResult = Apollo.MutationResult<ExportOpsOrderMutation>;
export type ExportOpsOrderMutationOptions = Apollo.BaseMutationOptions<ExportOpsOrderMutation, ExportOpsOrderMutationVariables>;